export const ru = {
  'app.name': 'Слой',
  'language.label': 'Язык интерфейса',
  'language.ru': 'Русский',
  'language.en': 'English',
  'theme.label': 'Тема интерфейса',
  'theme.light': 'Светлая тема',
  'theme.dark': 'Тёмная тема',
  'login.error': 'Не удалось войти. Попробуйте ещё раз.',
  'login.emailRequired': 'Сначала введите email.',
  'login.emailNotVerified': 'Сначала подтвердите адрес электронной почты — проверьте входящие или запросите письмо повторно.',
  'login.checkInbox': 'Проверьте входящие.',
  'verify.title': 'Подтвердите email',
  'verify.checkingLink': 'Проверяем ссылку из письма…',
  'verify.enterCodeSentTo': 'Введите 6-значный код из письма, отправленного на {email}.',
  'verify.enterCodeOrResend': 'Введите код из письма или запросите новое письмо.',
  'verify.codeValidFor': 'Код действителен ещё',
  'verify.codeExpired': 'Срок действия кода истёк — нажмите «Отправить письмо снова».',
  'verify.codeLabel': 'Код из письма',
  'verify.checking': 'Проверяем…',
  'verify.submit': 'Подтвердить',
  'verify.resend': 'Отправить письмо снова',
  'verify.backToLogin': 'На страницу входа',
  'verify.emailRequired': 'Укажите email.',
  'verify.codeFormat': 'Введите 6 цифр кода из письма.',
  'verify.resendOk': 'Если адрес зарегистрирован, проверьте почту.',
  'verify.resendTooMany': 'Слишком много запросов. Попробуйте позже.',
  'verify.linkInvalid': 'Ссылка недействительна или истекла. Введите код из письма.',
  'verify.linkCheckFailed': 'Не удалось проверить ссылку. Попробуйте чуть позже или введите код из письма.',
  'verify.invalidCode': 'Неверный или просроченный код или ссылка.',
  'verify.tooManyAttempts': 'Слишком много попыток. Запросите новый код и попробуйте снова.',
  'verify.submitError': 'Не удалось подтвердить. Проверьте код и срок действия.',
  'forgot.title': 'Сброс пароля',
  'forgot.description': 'Введите эл. почту, и мы отправим вам ссылку для сброса пароля',
  'forgot.success': 'Если этот email зарегистрирован, вы получите письмо со ссылкой для сброса пароля. Проверьте почту.',
  'forgot.sendError': 'Не удалось отправить письмо. Попробуйте позже.',
  'forgot.sending': 'Отправляем...',
  'forgot.submit': 'Сбросить пароль',
  'forgot.backToLogin': 'Вернуться ко входу',
  'reset.mismatch': 'Пароли не совпадают',
  'reset.tooShort': 'Пароль должен быть не менее 8 символов',
  'reset.invalidLinkShort': 'Недействительная ссылка',
  'reset.submitError': 'Не удалось сбросить пароль. Ссылка могла истечь.',
  'reset.errorTitle': 'Ошибка',
  'reset.invalidLink': 'Недействительная ссылка. Запросите сброс пароля повторно.',
  'reset.requestAgain': 'Запросить сброс пароля',
  'reset.title': 'Новый пароль',
  'reset.description': 'Введите новый пароль для вашего аккаунта',
  'reset.success': 'Пароль успешно изменён. Перенаправление на страницу входа...',
  'reset.newPassword': 'Новый пароль',
  'reset.newPasswordPlaceholder': 'Минимум 8 символов',
  'reset.confirmPassword': 'Подтвердите пароль',
  'reset.confirmPasswordPlaceholder': 'Повторите пароль',
  'reset.saving': 'Сохраняем...',
  'reset.submit': 'Сбросить пароль',
  'login.resendError': 'Не удалось отправить письмо.',
  'login.resending': 'Отправляем…',
  'login.resend': 'Отправить письмо подтверждения снова',
  'login.enterCode': 'Ввести код из письма',
  'login.password': 'Пароль',
  'login.forgotPassword': 'Забыли пароль?',
  'login.passwordPlaceholder': 'Введите пароль',
  'login.submitting': 'Входим...',
  'login.submit': 'Войти',
  'auth.tabLogin': 'Вход',
  'auth.tabRegister': 'Регистрация',
  'auth.email': 'Почта',
  'auth.emailPlaceholder': 'you@example.ru',
  'password.show': 'Показать пароль',
  'password.hide': 'Скрыть пароль',
  'register.name': 'Имя',
  'register.namePlaceholder': 'Как вас зовут',
  'register.password': 'Пароль',
  'register.passwordPlaceholder': 'Минимум 8 символов',
  'register.submitting': 'Регистрируем...',
  'register.submit': 'Зарегистрироваться',
  'register.genericError': 'Не удалось создать аккаунт. Попробуйте ещё раз.',
  'register.legalPrefix': 'Заполняя форму, вы принимаете условия',
  'register.legalOfferLink': 'публичной оферты',
  'register.legalAnd': 'и даёте',
  'register.legalConsentLink': 'согласие',
  'register.legalConsentSuffix': 'на обработку персональных данных',
  'dashboard.projects': 'Проекты',
  'dashboard.allProjects': 'Все проекты',
  'dashboard.shared': 'Расшаренные',
  'dashboard.favorites': 'Избранные',
  'dashboard.support': 'Поддержка',
  'dashboard.letter': 'Письмо от авторов',
  'dashboard.letterShort': 'Письмо от авторов',
  // Текст письма типографирован: \u00A0 — неразрывный пробел, \u2060 вокруг дефиса — «не переноси слово».
  // Пробелы вокруг ссылки `p5link` — в самих строках `p5a`/`p5b`: в английском после неё тире без пробела.
  'letter.p1': 'Привет! Это Павел Лефранк, один из\u00A0создателей «Слоя».',
  'letter.p2': 'Много лет назад мы\u00A0подумали, что было\u00A0бы круто иметь сервис для создания красивых карт в\u00A0вебе. Причём для обычных людей, а\u00A0не\u00A0для гиков. Несколько лет работы по\u00A0вечерам и\u00A0ночам\u00A0— и\u00A0наконец\u2060-\u2060то всё заработало.',
  'letter.p3': 'Сегодня «Слой» помогает быстро собрать карту для чего угодно: для себя, друзей, хобби, работы, проектов, коллекций и\u00A0т.\u00A0д.\u00A0— и\u00A0поделиться ей\u00A0с\u00A0миром. Мы\u00A0очень хотим, чтобы делать свои карты стало так\u00A0же просто, как вести заметки.',
  'letter.p4': 'Пока что «Слой» бесплатный. Но\u00A0проект нужно содержать и\u00A0развивать, поэтому скоро появятся платные тарифы. Бесплатный тариф останется, но\u00A0с\u00A0лимитами. Тут иначе никак, увы.',
  'letter.p5a': 'Ещё какое\u2060-\u2060то время сервис будет бесплатным и\u00A0без ограничений, чтобы все успели попробовать его в\u00A0деле. Но\u00A0если хотите поддержать нас на\u00A0старте\u00A0— ',
  'letter.p5link': 'подписку можно оформить',
  'letter.p5b': ' уже сейчас, будем безумно рады!',
  'letter.p6': 'Для первых пользователей, которые пришли до\u00A0полноценного релиза, мы\u00A0потом придумаем какие\u2060-\u2060нибудь скидки, поэтому приглашайте друзей и\u00A0коллег запрыгнуть в\u00A0вагон :-)',
  'letter.p7': 'Для НКО и\u00A0учебных заведений также будут скидки, вплоть до\u00A0100%, имейте в\u00A0виду. Мы\u00A0всегда готовы помочь хорошим делам.',
  'letter.p8': 'Обнимаю и\u00A0спасибо, что вы\u00A0с\u00A0нами! С\u00A0любым фидбеком не\u00A0стесняйтесь и\u00A0пишите прямо мне в\u00A0личку\u00A0—',
  'letter.signature': 'Эникрафт',
  'dashboard.noFavorites': 'Пока нет избранных',
  'dashboard.createProject': 'Создать проект',
  'dashboard.creatingProject': 'Создаём...',
  'dashboard.defaultProjectName': 'Проект {number}',
  'dashboard.emptyAllTitle': 'Проектов пока нет',
  'dashboard.emptyAllDescription': 'Создайте первый проект кнопкой «Создать проект» выше, чтобы начать работу с картой.',
  'dashboard.emptySharedTitle': 'Нет расшаренных проектов',
  'dashboard.emptySharedDescription': 'Когда коллеги пригласят вас в проект, он появится в этом разделе.',
  'project.roleEditor': 'Редактор',
  'project.roleViewer': 'Просмотр',
  'project.menu': 'Меню',
  'project.rename': 'Переименовать',
  'project.duplicate': 'Дублировать',
  'project.duplicateToOwn': 'Дублировать к себе',
  'project.duplicating': 'Дублируем...',
  'project.copyName': '{name} (копия)',
  'project.duplicated': 'Создана копия «{name}»',
  'project.duplicatedTo': 'Создана копия «{name}» в «{workspace}»',
  'project.duplicateError': 'Не удалось дублировать проект',
  'project.delete': 'Удалить',
  'project.updated': 'Обновлён {date}',
  'project.removeFavorite': 'Убрать из избранного',
  'project.addFavorite': 'Добавить в избранное',
  'project.deleteTitle': 'Удалить проект?',
  'project.deleteDescription': 'Проект «{name}» и все его данные будут удалены безвозвратно.',
  'project.cancel': 'Отмена',
  'project.deleting': 'Удаление...',
  'project.renameTitle': 'Переименовать проект',
  'project.namePlaceholder': 'Название проекта',
  'project.saving': 'Сохранение...',
  'project.save': 'Сохранить',
  'profile.title': 'Профиль',
  'profile.avatarUpdated': 'Аватар обновлён',
  'profile.avatarError': 'Не удалось загрузить аватар',
  'profile.deleteAvatar': 'Удалить аватар',
  'profile.avatarDeleted': 'Аватар удалён',
  'profile.avatarDeleteError': 'Не удалось удалить аватар',
  'profile.uploading': 'Загрузка…',
  'profile.uploadPhoto': 'Загрузить фото',
  'profile.photoHint': 'До 2 МБ, JPEG, PNG, WebP или HEIC',
  'profile.name': 'Имя',
  'profile.editName': 'Изменить имя',
  'profile.cancel': 'Отмена',
  'profile.nameUpdated': 'Имя обновлено',
  'profile.nameError': 'Не удалось обновить имя',
  'profile.saving': 'Сохраняем…',
  'profile.save': 'Сохранить',
  'profile.security': 'Безопасность',
  'profile.changePassword': 'Смена пароля',
  'profile.currentPassword': 'Текущий пароль',
  'profile.newPassword': 'Новый пароль',
  'profile.repeatPassword': 'Повтор пароля',
  'profile.passwordMismatch': 'Пароли не совпадают',
  'profile.passwordChanged': 'Пароль изменён. Другие устройства будут выведены из системы.',
  'profile.passwordError': 'Не удалось изменить пароль. Проверьте текущий пароль.',
  'profile.savePassword': 'Сохранить пароль',
  'profile.emailConfirmTitle': 'Подтверждение нового email',
  'profile.currentEmail': 'Текущий email:',
  'profile.emailCodeHint': 'Введите 6-значный код из письма, отправленного на новый адрес',
  'profile.emailCode': 'Код из письма',
  'profile.checking': 'Проверяем…',
  'profile.confirm': 'Подтвердить',
  'profile.back': 'Назад',
  'profile.emailChangeTitle': 'Смена почты',
  'profile.emailChangeHint': 'Новый адрес для входа. Подтверждение придёт на новую почту.',
  'profile.newEmail': 'Новый email',
  'profile.requestEmailChange': 'Запросить смену почты',
  'profile.emailLinkSent': 'Ссылка отправлена. Проверьте почту и введите код.',
  'profile.emailRequestError': 'Не удалось запросить смену email. Проверьте пароль.',
  'profile.emailChanged': 'Email успешно изменён.',
  'profile.emailCodeError': 'Неверный или просроченный код.',
  'profile.plan': 'Тариф',
  'profile.planFree': 'Эксклюзивный',
  'profile.planDescription': 'Сейчас все функции бесплатны. В будущем появятся платные тарифы.',
  'profile.planUnlimitedAll': 'Безлимит на всё',
  'profile.statsSection': 'Статистика',
  'profile.statProjects': 'Проекты',
  'profile.statPoints': 'Точки',
  'profile.statPresentations': 'Презентации',
  'profile.statFiles': 'Объём файлов',
  'profile.statViews': 'Просмотры карт',
  'profile.statsEmpty': 'Пока пусто. Создайте первый проект — и здесь появится статистика.',
  'profile.legal': 'Уголок потребителя',
  'profile.legalDescription': 'Документы, которые мы обязаны разместить',
  'profile.legalOffer': 'Публичная оферта',
  'profile.legalPrivacyPolicy': 'Политика конфиденциальности',
  'profile.legalConsent': 'Согласие на обработку персональных данных',
  'profile.logout': 'Выйти из аккаунта',
  'admin.title': 'Админка',
  'admin.nav.overview': 'Обзор',
  'admin.nav.workspaces': 'Команды',
  'admin.nav.users': 'Пользователи',
  'admin.nav.projects': 'Проекты',
  'admin.stat.totalUsers': 'Всего пользователей',
  'admin.stat.verifiedUsers': 'Подтверждённых',
  'admin.stat.totalProjects': 'Всего проектов',
  'admin.stat.publicProjects': 'Публичных',
  'admin.stat.layers': 'Слоёв',
  'admin.stat.features': 'Объектов',
  'admin.stat.uploads': 'Загрузок',
  'admin.stat.comments': 'Комментариев',
  'admin.stat.presentations': 'Презентаций',
  'admin.stat.pmtiles': 'Размер тайлов',
  'admin.chart.usersGrowth': 'Регистрации (30 дней)',
  'admin.chart.projectsGrowth': 'Новые проекты (30 дней)',
  'admin.integrations.title': 'Интеграции по провайдерам',
  'admin.integrations.empty': 'Интеграций пока нет',
  'admin.users.searchPlaceholder': 'Поиск по email или имени',
  'admin.users.colEmail': 'Email',
  'admin.users.colName': 'Имя',
  'admin.users.colVerified': 'Подтверждён',
  'admin.users.colProjects': 'Проектов',
  'admin.users.colCreated': 'Регистрация',
  'admin.users.badgeAdmin': 'Админ',
  'admin.users.empty': 'Пользователи не найдены',
  'admin.projects.searchPlaceholder': 'Поиск по названию или email владельца',
  'admin.projects.colName': 'Проект',
  'admin.projects.colOwner': 'Владелец',
  'admin.projects.colVisibility': 'Доступ',
  'admin.projects.colLayers': 'Слоёв',
  'admin.projects.colFeatures': 'Объектов',
  'admin.projects.colSize': 'Размер',
  'admin.projects.colUpdated': 'Обновлён',
  'admin.projects.public': 'Публичный',
  'admin.projects.private': 'Приватный',
  'admin.projects.empty': 'Проекты не найдены',
  'admin.projects.openDetails': 'Открыть карточку проекта',
  'admin.detail.storage': 'Хранилище',
  'admin.detail.dbBytes': 'Данные (БД)',
  'admin.detail.pmtilesBytes': 'Тайлы (pmtiles)',
  'admin.detail.s3Bytes': 'Файлы (S3)',
  'admin.detail.totalBytes': 'Всего',
  'admin.detail.layers': 'Слои',
  'admin.detail.owner': 'Владелец',
  'admin.detail.projectsOwned': 'Проекты',
  'admin.detail.created': 'Создан',
  'admin.detail.loadingS3': 'Считаем размер файлов…',
  'admin.common.loadError': 'Не удалось загрузить данные',
  'admin.common.prev': 'Назад',
  'admin.common.next': 'Вперёд',
  'admin.common.pageInfo': '{from}–{to} из {total}',
  'admin.sort.label': 'Сортировка',
  'admin.sort.newest': 'Сначала новые',
  'admin.sort.oldest': 'Сначала старые',
  'admin.sort.email': 'По email',
  'admin.sort.projects': 'По проектам',
  'admin.sort.name': 'По названию',
  'admin.stat.workspaces': 'Команд',
  'admin.stat.billableUsers': 'Платных участников',
  'admin.workspaces.searchPlaceholder': 'Поиск по названию, адресу или email владельца',
  'admin.workspaces.colName': 'Команда',
  'admin.workspaces.colWayfinding': 'Навигация',
  'admin.workspaces.colOwner': 'Владелец',
  'admin.workspaces.colMembers': 'Платных / всего',
  'admin.workspaces.colProjects': 'Карт',
  'admin.workspaces.colStorage': 'Место',
  'admin.workspaces.colViews': 'Просмотров за месяц',
  'admin.workspaces.colCreated': 'Создана',
  'admin.workspaces.planHint': 'Тариф команды',
  'admin.workspaces.empty': 'Команды не найдены',
  'admin.sort.members': 'По участникам',
  'admin.sort.billable': 'По платным',
  'admin.sort.views': 'По просмотрам',
  'admin.sort.size': 'По размеру',
  'admin.moderation.suspended': 'Заморожена',
  'admin.moderation.suspend': 'Заморозить',
  'admin.moderation.unsuspend': 'Разморозить',
  'admin.moderation.reasonLabel': 'Причина',
  'admin.moderation.reasonPlaceholder': 'Что именно нарушено и по чьей жалобе',
  'admin.moderation.reasonHint': 'Причину увидит владелец. Она же останется в журнале как мотивировка решения.',
  'admin.moderation.confirmTitleWorkspace': 'Заморозить команду',
  'admin.moderation.confirmTitleProject': 'Заморозить карту',
  'admin.moderation.confirmBodyWorkspace': 'Публичные карты команды перестанут открываться, поддомен отдаст заглушку. Данные останутся на месте, владелец сохранит доступ к редактору.',
  'admin.moderation.confirmBodyProject': 'Карта перестанет открываться публично: страница, встройка, презентация и тайлы. Данные останутся на месте, владелец сохранит доступ к редактору.',
  'admin.moderation.suspendedBy': 'Заморозил',
  'admin.moderation.suspendedAt': 'Заморожена',
  'admin.moderation.cancel': 'Отмена',
  'admin.moderation.failed': 'Не удалось изменить статус',
  'workspace.switcher.label': 'Выбрать воркспейс',
  'workspace.switcher.fallback': 'Воркспейс',
  'workspace.switcher.groupTitle': 'Воркспейсы',
  'workspace.switcher.create': 'Создать воркспейс',
  'workspace.switcher.settings': 'Настройки воркспейса',
  'agents.title': 'ИИ-агенты (MCP)',
  'agents.description': 'Агенты работают от вашего имени с картами команд на тарифах Про Макс и «Компания». Права токена можно сузить; при смене пароля все токены отзываются.',
  'agents.descriptionAnyPlan': 'Агенты работают от вашего имени с картами ваших команд. Права токена можно сузить; при смене пароля все токены отзываются.',
  'agents.planRequired': 'ИИ-агенты доступны на тарифах Про Макс и «Компания». Подключите Про Макс в своей команде — и сможете выпустить токен.',
  'agents.planRequiredWithTokens': 'Ни одна из ваших команд сейчас не на Про Макс или «Компании»: выпущенные токены не откроют агентам ни одной карты, а новые выпустить нельзя.',
  'agents.upgrade': 'Подключить Про Макс',
  'agents.disabled': 'MCP-сервер на этом сервере выключен: токены не будут работать, пока его не включат.',
  'agents.empty': 'Токенов пока нет.',
  'agents.create': 'Создать токен',
  'agents.creating': 'Создаём…',
  'agents.createTitle': 'Новый токен агента',
  'agents.createDescription': 'Токен даёт агенту доступ к вашим картам в пределах выбранных прав.',
  'agents.name': 'Название',
  'agents.scopes': 'Права',
  'agents.expiry': 'Срок действия',
  'agents.ttlDays': '{days} дн.',
  'agents.scope.read': 'Чтение карт',
  'agents.scope.write': 'Изменение карт',
  'agents.scope.delete': 'Удаление',
  'agents.scope.publish': 'Публикация',
  'agents.created': 'Создан {date}',
  'agents.expires': 'Истекает {date}',
  'agents.lastUsed': 'Использован: {date}',
  'agents.never': 'никогда',
  'agents.revoke': 'Отозвать',
  'agents.revokeNamed': 'Отозвать токен {name}',
  'agents.revokeTitle': 'Отозвать токен?',
  'agents.revokeDescription': 'Токен «{name}» перестанет работать сразу. Это нельзя отменить.',
  'agents.revokeAll': 'Отозвать все',
  'agents.revokeAllTitle': 'Отозвать все токены?',
  'agents.revokeAllDescription': 'Все токены агентов перестанут работать сразу. Это нельзя отменить.',
  'agents.revoked': 'Токен отозван',
  'agents.revokeError': 'Не удалось отозвать токен',
  'agents.connectTitle': 'Подключите агента',
  'agents.connectDescription': 'Ключ уже вставлен в команду — выполните её для своего агента.',
  'agents.shownOnce': 'Окно показывается один раз. Закроете, не подключив агента, — создайте новый токен.',
  'agents.hintClaude': 'Выполните в терминале — Claude Code подключит Слой во всех ваших проектах.',
  'agents.hintCodex': 'Выполните в терминале — команда добавит Слой в ~/.codex/config.toml.',
  'agents.hintCursor': 'Откроется Cursor и предложит добавить Слой.',
  'agents.addToCursor': 'Добавить в Cursor',
  'agents.copyCommand': 'Скопировать команду',
  'agents.copy': 'Копировать',
  'agents.copied': 'Скопировано',
  'agents.copyFailed': 'Не скопировалось',
  'agents.copyFailedHint': 'Буфер обмена недоступен — выделите текст и скопируйте вручную.',
  'agents.done': 'Готово',
  'agents.errorLimit': 'Достигнут лимит: не больше {max} действующих токенов. Отзовите ненужные.',
  'agents.errorRate': 'Слишком много попыток. Повторите позже.',
  'agents.errorGeneric': 'Не удалось создать токен. Попробуйте ещё раз.',
} as const;

export type TranslationKey = keyof typeof ru;

export const en = {
  'app.name': 'Sloy',
  'language.label': 'Interface language',
  'language.ru': 'Русский',
  'language.en': 'English',
  'theme.label': 'Interface theme',
  'theme.light': 'Light theme',
  'theme.dark': 'Dark theme',
  'login.error': 'Could not sign in. Please try again.',
  'login.emailRequired': 'Enter your email first.',
  'login.emailNotVerified': 'Verify your email first — check your inbox or request another verification email.',
  'login.checkInbox': 'Check your inbox.',
  'verify.title': 'Confirm your email',
  'verify.checkingLink': 'Checking the link from the email…',
  'verify.enterCodeSentTo': 'Enter the 6-digit code from the email sent to {email}.',
  'verify.enterCodeOrResend': 'Enter the code from the email or request a new one.',
  'verify.codeValidFor': 'The code is valid for another',
  'verify.codeExpired': 'The code has expired. Click “Send the email again”.',
  'verify.codeLabel': 'Code from the email',
  'verify.checking': 'Checking…',
  'verify.submit': 'Confirm',
  'verify.resend': 'Send the email again',
  'verify.backToLogin': 'Back to sign in',
  'verify.emailRequired': 'Enter your email.',
  'verify.codeFormat': 'Enter the 6 digits of the code from the email.',
  'verify.resendOk': 'If this address is registered, check your inbox.',
  'verify.resendTooMany': 'Too many requests. Please try again later.',
  'verify.linkInvalid': 'The link is invalid or has expired. Enter the code from the email.',
  'verify.linkCheckFailed': 'Could not check the link. Try again in a moment or enter the code from the email.',
  'verify.invalidCode': 'Invalid or expired code or link.',
  'verify.tooManyAttempts': 'Too many attempts. Request a new code and try again.',
  'verify.submitError': 'Could not confirm. Check the code and its expiry.',
  'forgot.title': 'Reset password',
  'forgot.description': 'Enter your email and we will send you a link to reset your password',
  'forgot.success': 'If this email is registered, you will receive a message with a password reset link. Check your inbox.',
  'forgot.sendError': 'Could not send the email. Please try again later.',
  'forgot.sending': 'Sending...',
  'forgot.submit': 'Reset password',
  'forgot.backToLogin': 'Back to sign in',
  'reset.mismatch': 'Passwords do not match',
  'reset.tooShort': 'The password must be at least 8 characters',
  'reset.invalidLinkShort': 'Invalid link',
  'reset.submitError': 'Could not reset the password. The link may have expired.',
  'reset.errorTitle': 'Error',
  'reset.invalidLink': 'Invalid link. Request a password reset again.',
  'reset.requestAgain': 'Request a password reset',
  'reset.title': 'New password',
  'reset.description': 'Enter a new password for your account',
  'reset.success': 'Password changed. Redirecting to the sign-in page...',
  'reset.newPassword': 'New password',
  'reset.newPasswordPlaceholder': 'At least 8 characters',
  'reset.confirmPassword': 'Confirm password',
  'reset.confirmPasswordPlaceholder': 'Repeat the password',
  'reset.saving': 'Saving...',
  'reset.submit': 'Reset password',
  'login.resendError': 'Could not send the email.',
  'login.resending': 'Sending…',
  'login.resend': 'Resend verification email',
  'login.enterCode': 'Enter the code from the email',
  'login.password': 'Password',
  'login.forgotPassword': 'Forgot password?',
  'login.passwordPlaceholder': 'Enter your password',
  'login.submitting': 'Signing in...',
  'login.submit': 'Sign in',
  'auth.tabLogin': 'Sign in',
  'auth.tabRegister': 'Sign up',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'you@example.com',
  'password.show': 'Show password',
  'password.hide': 'Hide password',
  'register.name': 'Name',
  'register.namePlaceholder': 'Your name',
  'register.password': 'Password',
  'register.passwordPlaceholder': 'At least 8 characters',
  'register.submitting': 'Signing up...',
  'register.submit': 'Sign up',
  'register.genericError': 'Could not create the account. Please try again.',
  'register.legalPrefix': 'By clicking “Sign up”, you accept the',
  'register.legalOfferLink': 'Terms of Service',
  'register.legalAnd': 'and',
  'register.legalConsentLink': 'consent',
  'register.legalConsentSuffix': 'to the processing of your personal data',
  'dashboard.projects': 'Projects',
  'dashboard.allProjects': 'All projects',
  'dashboard.shared': 'Shared with me',
  'dashboard.favorites': 'Favorites',
  'dashboard.support': 'Support',
  'dashboard.letter': 'A letter from the Sloy team',
  'dashboard.letterShort': 'A letter from the team',
  'letter.p1': "Hey there! Paul Lefrank here, co-author of Sloy.",
  'letter.p2': "Years ago, we had an idea: wouldn’t it be awesome to have a tool that lets anyone build beautiful web maps? Not just for GIS pros and techies, but for everyday people. After a few years of late nights and weekends, it’s finally alive and kicking.",
  'letter.p3': "Today, Sloy makes it easy to build a custom map for practically anything—personal memories, friends, side projects, hobbies, work, collections, you name it—and share it with the world. Our goal is simple: we want making maps to feel as effortless as jotting down notes.",
  'letter.p4': "Right now, Sloy is completely free. But running and growing a product takes real resources, so we’ll be introducing paid plans soon. There will always be a free tier, but with limits. Sadly, there’s no way around that.",
  'letter.p5a': "For a little while longer, though, Sloy will stay completely free with zero restrictions so everyone can take it for a real spin. That said, if you’d like to back us early, ",
  'letter.p5link': 'you can already subscribe',
  'letter.p5b': "—it would mean the world to us!",
  'letter.p6': "For early adopters who jump in before our official launch, we’re definitely putting together special perks and discounts down the line, so feel free to invite friends and colleagues to hop on board :)",
  'letter.p7': "Also, quick note: we’ll have discounts up to 100% for non-profits and educational institutions. We’re always eager to back good causes.",
  'letter.p8': "Big hugs and thank you for being here with us! If you have any feedback at all, don’t hesitate to shoot me a DM directly:",
  'letter.signature': 'Anycraft',
  'dashboard.noFavorites': 'No favorites yet',
  'dashboard.createProject': 'Create project',
  'dashboard.creatingProject': 'Creating...',
  'dashboard.defaultProjectName': 'Project {number}',
  'dashboard.emptyAllTitle': 'No projects yet',
  'dashboard.emptyAllDescription': 'Create your first project with the “Create project” button above to start working on a map.',
  'dashboard.emptySharedTitle': 'No shared projects',
  'dashboard.emptySharedDescription': 'Projects your teammates invite you to will appear here.',
  'project.roleEditor': 'Editor',
  'project.roleViewer': 'Viewer',
  'project.menu': 'Menu',
  'project.rename': 'Rename',
  'project.duplicate': 'Duplicate',
  'project.duplicateToOwn': 'Duplicate to my workspace',
  'project.duplicating': 'Duplicating...',
  'project.copyName': '{name} (copy)',
  'project.duplicated': '“{name}” copy created',
  'project.duplicatedTo': '“{name}” copy created in “{workspace}”',
  'project.duplicateError': 'Could not duplicate the project',
  'project.delete': 'Delete',
  'project.updated': 'Updated {date}',
  'project.removeFavorite': 'Remove from favorites',
  'project.addFavorite': 'Add to favorites',
  'project.deleteTitle': 'Delete project?',
  'project.deleteDescription': '“{name}” and all its data will be permanently deleted.',
  'project.cancel': 'Cancel',
  'project.deleting': 'Deleting...',
  'project.renameTitle': 'Rename project',
  'project.namePlaceholder': 'Project name',
  'project.saving': 'Saving...',
  'project.save': 'Save',
  'profile.title': 'Profile',
  'profile.avatarUpdated': 'Profile picture updated',
  'profile.avatarError': 'Could not upload the profile picture',
  'profile.deleteAvatar': 'Remove photo',
  'profile.avatarDeleted': 'Profile picture removed',
  'profile.avatarDeleteError': 'Could not remove the profile picture',
  'profile.uploading': 'Uploading…',
  'profile.uploadPhoto': 'Upload photo',
  'profile.photoHint': 'Up to 2 MB, JPEG, PNG, WebP, or HEIC',
  'profile.name': 'Name',
  'profile.editName': 'Edit name',
  'profile.cancel': 'Cancel',
  'profile.nameUpdated': 'Name updated',
  'profile.nameError': 'Could not update the name',
  'profile.saving': 'Saving…',
  'profile.save': 'Save',
  'profile.security': 'Security',
  'profile.changePassword': 'Change password',
  'profile.currentPassword': 'Current password',
  'profile.newPassword': 'New password',
  'profile.repeatPassword': 'Repeat password',
  'profile.passwordMismatch': 'Passwords do not match',
  'profile.passwordChanged': 'Password changed. Other devices have been signed out.',
  'profile.passwordError': 'Could not change the password. Check your current password.',
  'profile.savePassword': 'Save password',
  'profile.emailConfirmTitle': 'Confirm new email',
  'profile.currentEmail': 'Current email:',
  'profile.emailCodeHint': 'Enter the 6-digit code sent to your new email address',
  'profile.emailCode': 'Email code',
  'profile.checking': 'Checking…',
  'profile.confirm': 'Confirm',
  'profile.back': 'Back',
  'profile.emailChangeTitle': 'Change email',
  'profile.emailChangeHint': 'Use a new address to sign in. A confirmation email will be sent there.',
  'profile.newEmail': 'New email',
  'profile.requestEmailChange': 'Request email change',
  'profile.emailLinkSent': 'Link sent. Check your inbox and enter the code.',
  'profile.emailRequestError': 'Could not request an email change. Check your password.',
  'profile.emailChanged': 'Email changed successfully.',
  'profile.emailCodeError': 'The code is invalid or has expired.',
  'profile.plan': 'Plan',
  'profile.planFree': 'Exclusive',
  'profile.planDescription': 'All features are currently free. Paid plans will be introduced in the future.',
  'profile.planUnlimitedAll': 'Unlimited everything',
  'profile.statsSection': 'Statistics',
  'profile.statProjects': 'Projects',
  'profile.statPoints': 'Points',
  'profile.statPresentations': 'Presentations',
  'profile.statFiles': 'Files size',
  'profile.statViews': 'Map views',
  'profile.statsEmpty': 'Nothing yet. Create your first project and stats will show up here.',
  'profile.legal': 'Consumer corner',
  'profile.legalDescription': 'Documents and legal information about the service',
  'profile.legalOffer': 'Public offer',
  'profile.legalPrivacyPolicy': 'Privacy policy',
  'profile.legalConsent': 'Personal data processing consent',
  'profile.logout': 'Sign out',
  'admin.title': 'Admin',
  'admin.nav.overview': 'Overview',
  'admin.nav.workspaces': 'Workspaces',
  'admin.nav.users': 'Users',
  'admin.nav.projects': 'Projects',
  'admin.stat.totalUsers': 'Total users',
  'admin.stat.verifiedUsers': 'Verified',
  'admin.stat.totalProjects': 'Total projects',
  'admin.stat.publicProjects': 'Public',
  'admin.stat.layers': 'Layers',
  'admin.stat.features': 'Features',
  'admin.stat.uploads': 'Uploads',
  'admin.stat.comments': 'Comments',
  'admin.stat.presentations': 'Presentations',
  'admin.stat.pmtiles': 'Tiles size',
  'admin.chart.usersGrowth': 'Sign-ups (30 days)',
  'admin.chart.projectsGrowth': 'New projects (30 days)',
  'admin.integrations.title': 'Integrations by provider',
  'admin.integrations.empty': 'No integrations yet',
  'admin.users.searchPlaceholder': 'Search by email or name',
  'admin.users.colEmail': 'Email',
  'admin.users.colName': 'Name',
  'admin.users.colVerified': 'Verified',
  'admin.users.colProjects': 'Projects',
  'admin.users.colCreated': 'Registered',
  'admin.users.badgeAdmin': 'Admin',
  'admin.users.empty': 'No users found',
  'admin.projects.searchPlaceholder': 'Search by name or owner email',
  'admin.projects.colName': 'Project',
  'admin.projects.colOwner': 'Owner',
  'admin.projects.colVisibility': 'Visibility',
  'admin.projects.colLayers': 'Layers',
  'admin.projects.colFeatures': 'Features',
  'admin.projects.colSize': 'Size',
  'admin.projects.colUpdated': 'Updated',
  'admin.projects.public': 'Public',
  'admin.projects.private': 'Private',
  'admin.projects.empty': 'No projects found',
  'admin.projects.openDetails': 'Open project details',
  'admin.detail.storage': 'Storage',
  'admin.detail.dbBytes': 'Data (DB)',
  'admin.detail.pmtilesBytes': 'Tiles (pmtiles)',
  'admin.detail.s3Bytes': 'Files (S3)',
  'admin.detail.totalBytes': 'Total',
  'admin.detail.layers': 'Layers',
  'admin.detail.owner': 'Owner',
  'admin.detail.projectsOwned': 'Projects',
  'admin.detail.created': 'Created',
  'admin.detail.loadingS3': 'Calculating file size…',
  'admin.common.loadError': 'Failed to load data',
  'admin.common.prev': 'Prev',
  'admin.common.next': 'Next',
  'admin.common.pageInfo': '{from}–{to} of {total}',
  'admin.sort.label': 'Sort',
  'admin.sort.newest': 'Newest',
  'admin.sort.oldest': 'Oldest',
  'admin.sort.email': 'By email',
  'admin.sort.projects': 'By projects',
  'admin.sort.name': 'By name',
  'admin.stat.workspaces': 'Workspaces',
  'admin.stat.billableUsers': 'Billable members',
  'admin.workspaces.searchPlaceholder': 'Search by name, address or owner email',
  'admin.workspaces.colName': 'Workspace',
  'admin.workspaces.colWayfinding': 'Wayfinding',
  'admin.workspaces.colOwner': 'Owner',
  'admin.workspaces.colMembers': 'Billable / total',
  'admin.workspaces.colProjects': 'Maps',
  'admin.workspaces.colStorage': 'Storage',
  'admin.workspaces.colViews': 'Views this month',
  'admin.workspaces.colCreated': 'Created',
  'admin.workspaces.planHint': 'Workspace plan',
  'admin.workspaces.empty': 'No workspaces found',
  'admin.sort.members': 'By members',
  'admin.sort.billable': 'By billable',
  'admin.sort.views': 'By views',
  'admin.sort.size': 'By size',
  'admin.moderation.suspended': 'Suspended',
  'admin.moderation.suspend': 'Suspend',
  'admin.moderation.unsuspend': 'Unsuspend',
  'admin.moderation.reasonLabel': 'Reason',
  'admin.moderation.reasonPlaceholder': 'What was violated and who reported it',
  'admin.moderation.reasonHint': 'The owner will see this reason. It is also kept as the statement of reasons.',
  'admin.moderation.confirmTitleWorkspace': 'Suspend workspace',
  'admin.moderation.confirmTitleProject': 'Suspend map',
  'admin.moderation.confirmBodyWorkspace': 'Public maps of this workspace stop opening and the subdomain serves a stub. Data stays intact and the owner keeps editor access.',
  'admin.moderation.confirmBodyProject': 'The map stops being served publicly: page, embed, presentation and tiles. Data stays intact and the owner keeps editor access.',
  'admin.moderation.suspendedBy': 'Suspended by',
  'admin.moderation.suspendedAt': 'Suspended',
  'admin.moderation.cancel': 'Cancel',
  'admin.moderation.failed': 'Could not change the status',
  'workspace.switcher.label': 'Select workspace',
  'workspace.switcher.fallback': 'Workspace',
  'workspace.switcher.groupTitle': 'Workspaces',
  'workspace.switcher.create': 'Create workspace',
  'workspace.switcher.settings': 'Workspace settings',
  'agents.title': 'AI agents (MCP)',
  'agents.description': 'Agents act on your behalf on maps of teams on the Pro Max and Enterprise plans. Token permissions can be narrowed; changing your password revokes all tokens.',
  'agents.descriptionAnyPlan': 'Agents act on your behalf on maps of your teams. Token permissions can be narrowed; changing your password revokes all tokens.',
  'agents.planRequired': 'AI agents are available on the Pro Max and Enterprise plans. Upgrade one of your teams to Pro Max to create a token.',
  'agents.planRequiredWithTokens': 'None of your teams is on Pro Max or Enterprise right now: existing tokens give agents access to no maps, and new ones cannot be created.',
  'agents.upgrade': 'Upgrade to Pro Max',
  'agents.disabled': 'The MCP server is disabled on this server: tokens will not work until it is enabled.',
  'agents.empty': 'No tokens yet.',
  'agents.create': 'Create token',
  'agents.creating': 'Creating…',
  'agents.createTitle': 'New agent token',
  'agents.createDescription': 'The token gives an agent access to your maps within the selected permissions.',
  'agents.name': 'Name',
  'agents.scopes': 'Permissions',
  'agents.expiry': 'Expires in',
  'agents.ttlDays': '{days} days',
  'agents.scope.read': 'Read maps',
  'agents.scope.write': 'Edit maps',
  'agents.scope.delete': 'Delete',
  'agents.scope.publish': 'Publish',
  'agents.created': 'Created {date}',
  'agents.expires': 'Expires {date}',
  'agents.lastUsed': 'Last used: {date}',
  'agents.never': 'never',
  'agents.revoke': 'Revoke',
  'agents.revokeNamed': 'Revoke token {name}',
  'agents.revokeTitle': 'Revoke token?',
  'agents.revokeDescription': 'Token "{name}" will stop working immediately. This cannot be undone.',
  'agents.revokeAll': 'Revoke all',
  'agents.revokeAllTitle': 'Revoke all tokens?',
  'agents.revokeAllDescription': 'All agent tokens will stop working immediately. This cannot be undone.',
  'agents.revoked': 'Token revoked',
  'agents.revokeError': 'Could not revoke the token',
  'agents.connectTitle': 'Connect your agent',
  'agents.connectDescription': 'The key is already in the command — run it for your agent.',
  'agents.shownOnce': 'This window is shown only once. If you close it before connecting, create a new token.',
  'agents.hintClaude': 'Run in a terminal — Claude Code will connect Sloy in all your projects.',
  'agents.hintCodex': 'Run in a terminal — the command adds Sloy to ~/.codex/config.toml.',
  'agents.hintCursor': 'Cursor will open and offer to add Sloy.',
  'agents.addToCursor': 'Add to Cursor',
  'agents.copyCommand': 'Copy command',
  'agents.copy': 'Copy',
  'agents.copied': 'Copied',
  'agents.copyFailed': 'Copy failed',
  'agents.copyFailedHint': 'Clipboard is unavailable — select the text and copy it manually.',
  'agents.done': 'Done',
  'agents.errorLimit': 'Limit reached: at most {max} active tokens. Revoke unused ones.',
  'agents.errorRate': 'Too many attempts. Try again later.',
  'agents.errorGeneric': 'Could not create the token. Please try again.',
} satisfies Record<TranslationKey, string>;

export const translations = { ru, en } as const;

export type Language = keyof typeof translations;
